import { doesAuthenticatorSupportScopes, getAuthenticator } from '@ms/yammer-web-authenticators';

import { getAdalResourceForYammer } from '../domains/session/selectors';
import type { YammerState } from '../state/types';

import type { ManagedApiRequest } from './types';

const getResources = ({ resource }: ManagedApiRequest, state: YammerState) => [
  resource ?? getAdalResourceForYammer(state),
];

const getScopes = ({ scopes }: ManagedApiRequest, state: YammerState) => scopes ?? [getAdalResourceForYammer(state)];

type GetResourcesOrScopes = (request: ManagedApiRequest, state: YammerState) => string[];
export const getResourcesOrScopes: GetResourcesOrScopes = (request, state) =>
  doesAuthenticatorSupportScopes(getAuthenticator()) ? getScopes(request, state) : getResources(request, state);
